import { NavLink, Outlet, Link } from "react-router-dom";
import { useAuth } from "../../lib/useAuth";
import styles from "./AdminLayout.module.css";

export default function AdminLayout() {
  const { user, signOut } = useAuth();

  return (
    <div className={styles.shell}>
      <aside className={styles.side}>
        <Link to="/" className={styles.brand}>
          <span className={styles.brandDot} /> Aya<span className={styles.green}>.</span>tech / admin
        </Link>

        <nav className={styles.nav} aria-label="Panel admin">
          <NavLink end to="/admin" className={navCls}>
            <span className={styles.idx}>00</span> Dashboard
          </NavLink>
          <NavLink to="/admin/hero" className={navCls}>
            <span className={styles.idx}>01</span> Hero
          </NavLink>
          <NavLink to="/admin/portafolio" className={navCls}>
            <span className={styles.idx}>02</span> Portafolio
          </NavLink>
          <NavLink to="/admin/proyectos" className={navCls}>
            <span className={styles.idx}>03</span> Proyectos
          </NavLink>
          <NavLink to="/admin/servicios" className={navCls}>
            <span className={styles.idx}>04</span> Servicios
          </NavLink>
          <NavLink to="/admin/clientes" className={navCls}>
            <span className={styles.idx}>05</span> Clientes
          </NavLink>
        </nav>

        <footer className={styles.foot}>
          <span className="mono-tag">{user?.email}</span>
          <Link to="/" className={styles.backHome}>
            ← Volver al inicio
          </Link>
          <button onClick={signOut} className={styles.signout}>
            Cerrar sesión
          </button>
        </footer>
      </aside>

      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}

function navCls({ isActive }) {
  return [styles.link, isActive ? styles.linkActive : ""].join(" ");
}
